import { useEffect, useState } from 'react'
import { FaArrowRightLong } from "react-icons/fa6";
import { FaArrowLeftLong } from "react-icons/fa6";
import styles from './ExperienceSlider.module.css'
import { AppConstants } from '../../../AppConstants';

const ExperienceSlider = ({ ExperienceDataItem, nextExperienceItem, preExperienceItem }) => {

    const [fadIn, setfadIn] = useState(false)

    const HandleNext = () => {
        setfadIn(false);
        setTimeout(nextExperienceItem, 500)
    }

    const HandlePre = () => {
        setfadIn(false);
        setTimeout(preExperienceItem, 500)
    }

    useEffect(() => {
        setfadIn(true);
    }, [ExperienceDataItem])

    return (
        <div className={styles.content}>
            <div>
                <div className={`${styles.experience} ${fadIn ? styles['fade-in'] : ``}`}>
                    <p className={styles.role}>{ExperienceDataItem?.role}</p>
                    <p className={styles.name}>{ExperienceDataItem?.name}</p>
                    <p className={styles.name}>{ExperienceDataItem?.duration}</p>
                    <p className={styles.detail}>{ExperienceDataItem?.detail}</p>
                    {ExperienceDataItem?.skills &&
                        <div className={styles.gainskillcnt}>
                            <span>{AppConstants.CommonWords.TechStack}:</span>
                            <div className={styles.skillsgained}>
                                {
                                    ExperienceDataItem.skills?.map((item) => {
                                        return (
                                            <img src={item} alt={item.split('/').pop().split('.')[0]} key={item} loading="lazy" />
                                        )
                                    })
                                }
                            </div>
                        </div>
                    }
                </div>
                <div className={styles.buttons}>
                    <button className={styles['slider-button']} onClick={HandlePre} aria-label="Previous experience"><FaArrowLeftLong /></button>
                    <button className={styles['slider-button']} onClick={HandleNext} aria-label="Next experience"><FaArrowRightLong /></button>
                </div>
            </div>
        </div>
    )
}

export default ExperienceSlider
